import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function PhotoSlider({ photos = [] }) {
  const slides = photos.length > 0 ? photos : Array(4).fill(null);

  return (
    <div className="photo-slider-wrapper">
      <Swiper
        modules={[Navigation, Pagination, A11y]}
        spaceBetween={16}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        a11y={{ prevSlideMessage: 'Previous photo', nextSlideMessage: 'Next photo' }}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {slides.map((src, i) => (
          <SwiperSlide key={i}>
            {src ? (
              <img
                src={src}
                alt={`Program photo ${i + 1}`}
                className="photo-slide-img"
                loading="lazy"
              />
            ) : (
              <div className="photo-slide-placeholder" aria-label="Photo placeholder" />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default PhotoSlider;
